import React, { FC, useState, useCallback } from 'react';
import { IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { MenuTab } from 'types/MenuTabs';
import {
  AuthModal,
  BrandsModal,
  LanguageModal,
  NavModal,
  SelectCityModal,
} from 'components/modals';
import { useAppDispatch } from 'store/hooks/useAppSelector';
import { accountSlice } from 'store/reducers/AccountSlice/AccountSlice';

interface NavMobileProps {
  menuTabs: MenuTab[];
}

const NavMobile: FC<NavMobileProps> = ({ menuTabs }) => {
  const dispatch = useAppDispatch();
  const { clearAuthResponse } = accountSlice.actions;
  const [isMenuDrawer, setMenuIsDrawer] = useState<boolean>(false);
  const [authModal, setAuthModal] = useState<boolean>(false);
  const [isSelectCityModal, setIsSelectCityModal] = useState<boolean>(false);
  const [isLanguageModal, setIsLanguageModal] = useState<boolean>(false);
  const [brandsModal, setBrandsModal] = useState<boolean>(false);

  const handleMenuDrawerOpen = useCallback(() => {
    setMenuIsDrawer(true);
  }, [isMenuDrawer]);
  const handleMenuDrawerClose = useCallback(() => {
    setMenuIsDrawer(false);
  }, [isMenuDrawer]);

  const handleAuthModalOpen = useCallback(() => {
    setAuthModal(true);
  }, [authModal]);
  const handleAuthModalClose = useCallback(() => {
    setAuthModal(false);
    dispatch(clearAuthResponse());
  }, [authModal]);

  const handleSelectCityModalOpen = useCallback(() => {
    setIsSelectCityModal(true);
  }, [isSelectCityModal]);
  const handleSelectCityModalClose = useCallback(() => {
    setIsSelectCityModal(false);
  }, [isSelectCityModal]);

  const handleLanguageModalOpen = useCallback(() => {
    setIsLanguageModal(true);
  }, [isLanguageModal]);
  const handleLanguageModalClose = useCallback(() => {
    setIsLanguageModal(false);
  }, [isLanguageModal]);

  const handleBrandsModalOpen = useCallback(() => {
    setBrandsModal(true);
  }, [brandsModal]);
  const handleBrandsModalClose = useCallback(() => {
    setBrandsModal(false);
  }, [brandsModal]);

  return (
    <>
      <IconButton onClick={handleMenuDrawerOpen}>
        <MenuIcon color="primary" />
      </IconButton>
      <NavModal
        isOpen={isMenuDrawer}
        onClose={handleMenuDrawerClose}
        onAuthModalOpen={handleAuthModalOpen}
        onSelectCityModalOpen={handleSelectCityModalOpen}
        onLanguageModalOpen={handleLanguageModalOpen}
        handleBrandsModalOpen={handleBrandsModalOpen}
        menuTabs={menuTabs}
      />
      <AuthModal isOpen={authModal} onClose={handleAuthModalClose} />
      <SelectCityModal
        isOpen={isSelectCityModal}
        onClose={handleSelectCityModalClose}
      />
      <LanguageModal
        isOpen={isLanguageModal}
        onClose={handleLanguageModalClose}
      />
      <BrandsModal isOpen={brandsModal} onClose={handleBrandsModalClose} />
    </>
  );
};

export default NavMobile;
